import React, { useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Loading from "wonderbly-components/lib/Loading";
import injectScript from "src/common/utils/injectScript";
import linkFactory from "src/client/js/analytics/factory/link";
import { createPaypalSession, submitOrder } from "./helpers";
import { buildPaypalSdkUrl } from "src/client/js/view/utils/buildPaypalSdkUrl";
import {
  useCountry,
  useErrorMessages,
  useModel,
  useGlobalContent,
} from "src/client/js/view/hooks";
import "./PayPal.scss";

export const PayPal = ({ style: propsStyle }) => {
  const { topology } = useModel();
  const country = useCountry();
  const { payLaterButton } = useGlobalContent("checkout");
  const { sendErrorMessage } = useErrorMessages();

  const style = {
    layout: "vertical",
    size: "responsive",
    tagline: false,
    ...propsStyle,
  };

  const [isLoading, setIsLoading] = useState(true);
  const [isRendered, setIsRendered] = useState(false);
  const [containerElement, setContainerElement] = useState(null);

  const handleOnApprove = async (data) => {
    setIsLoading(true);
    try {
      await submitOrder(data, country);
    } catch (error) {
      setIsLoading(false);
      sendErrorMessage();
    }
  };

  useEffect(() => {
    if (containerElement) {
      injectScript(
        buildPaypalSdkUrl(topology.paypal?.clientId, country, payLaterButton),
        () => {
          setIsLoading(false);
        }
      );
    }
  }, [containerElement]);

  useEffect(() => {
    if (window.paypal && !isRendered && containerElement && !isLoading) {
      window.paypal
        // eslint-disable-next-line new-cap
        .Buttons({
          style,
          createOrder: createPaypalSession,
          onApprove: handleOnApprove,
          onClick: linkFactory({
            category: "Cart",
            action: "Pay with PayPal Checkout",
            label: "PayPal Checkout",
          }),
        })
        .render(containerElement);
      setIsRendered(true);
    }
  }, [containerElement, isRendered, containerElement, isLoading]);

  return (
    <div className="PayPal">
      {isLoading && <Loading relative xsmall />}
      <div
        ref={setContainerElement}
        id="paypal-buttons-container"
        className={cx("PayPal__buttons-container", {
          [`PayPal__buttons-container--loading`]: isLoading,
        })}
      />
    </div>
  );
};

PayPal.propTypes = {
  style: PropTypes.object,
};

export default PayPal;
